import React from "react";
//Extranal Import
// @mui
import Typography from "@material-ui/core/Typography";
// redux
import { RootState } from "../../store/reducers";
import { useSelector } from "react-redux";


const OrderProduct = (props: any) => {
  const { item } = props;
  const appState = useSelector((state: RootState) => state.appReducer);
  const {bookingForm, langValue} = appState;

  return (
    <div id="orderProductParent">
      <div className="row m-0 d-flex align-items-start">
        <div className={` col-12 px-0 ${langValue === "ar" ? " " : ""}`}>
          <div className="row m-0">
            <div className="col-12 px-0 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center ">
                <span
                  className={` ${
                    langValue === "ar"
                      ? "text-right"
                      : "text-left familysora600 "
                  }  numberListing d-flex align-items-center justify-content-center`}
                >
                  {langValue === "ar" ? (
                    <React.Fragment> {item.quantity} </React.Fragment>
                  ) : (
                    <React.Fragment> {item.quantity} </React.Fragment>
                  )}
                </span>
                <Typography
                  className="mx-2 my-0"
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  <strong className="toCapitialize d-flex familysora600">
                    {item.prod_title != null
                      ? item.prod_title?.en
                      : "Name is not available"}
                  </strong>
                </Typography>
              </div>
              <div className="d-flex align-items-center ">
              {(bookingForm?.slotsType == 1 && item?.multiple) && <span> ({appState.bookingForm?.NoGuest} Guest) x </span> }
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  className={`mx-2 my-0 ${
                    appState.langValue === "ar" ? `direction-ltr` : ""
                  }`}
                >
                  <strong className="toCapitialize d-flex familysora600">
                   {Number(Number(item?.price) * Number(item?.quantity)).toFixed(2)} KD
                  </strong>
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderProduct;
